/*!
 * projectContext.js — which project is open
 * © 2025 Rob Canning — GPLv3
 *
 * window.currentProjectName is set by loadProject (projectLoader.js) and, in
 * Live, by liveMedia.js. Before either has run, the page's ?project= names the
 * project about to open. Callers pass the name their storage uses when there
 * is no project at all, since stored data already sits under those names.
 *
 * A leaf: no imports, so Live and node tests load it alone.
 */
export function projectName(fallback = "") {
  return window.currentProjectName
    || new URLSearchParams(globalThis.location?.search || "").get("project")
    || fallback;
}
